import { render, staticRenderFns } from "./CommissionSplitManage.vue?vue&type=template&id=160fad27"
import script from "./CommissionSplitManage.vue?vue&type=script&lang=js"
export * from "./CommissionSplitManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports